import type { i18n as I18n } from "i18next";
import en from "@/locales/en/puzzle-types/mastermind.json";
import fr from "@/locales/fr/puzzle-types/mastermind.json";

export const MASTERMIND_NS = "puzzle-types/mastermind";

/** Adds this type's translations to an initialised i18next instance (idempotent). */
export function registerMastermindTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", MASTERMIND_NS))
    i18n.addResourceBundle("en", MASTERMIND_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", MASTERMIND_NS))
    i18n.addResourceBundle("fr", MASTERMIND_NS, fr, true, true);
}
